export default __webpack_public_path__ + "static/media/oops.adaf1f58.png";